export default __webpack_public_path__ + "static/media/mk.9432e7d9.svg";